import { useState, useEffect } from 'react';
import type { ScriptStyle } from '../types/api';
import { ensureScriptStyles } from '../services/scriptStyles';

interface ScriptStyleSelectorProps {
  value?: string;
  onChange?: (styleId: string) => void;
}

export default function ScriptStyleSelector({ value, onChange }: ScriptStyleSelectorProps) {
  const [styles, setStyles] = useState<ScriptStyle[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    ensureScriptStyles()
      .then((loadedStyles) => {
        if (mounted) {
          setStyles(loadedStyles);
          if (!value && loadedStyles.length > 0 && loadedStyles[0]) {
            onChange?.(loadedStyles[0].style_id);
          }
        }
      })
      .catch(() => {
        // fallback styles are handled by ensureScriptStyles
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const selectedId = value || (styles[0]?.style_id ?? '');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <select
      className="form-select"
      value={selectedId}
      onChange={handleChange}
      disabled={loading || styles.length === 0}
    >
      {loading ? (
        <option value="">加载风格...</option>
      ) : styles.length === 0 ? (
        <option value="">无可用风格</option>
      ) : (
        styles.map((style) => (
          <option key={style.style_id} value={style.style_id}>
            {style.display_name || style.style_id}
          </option>
        ))
      )}
    </select>
  );
}